import { Position } from '../../types'
import { useCallback, useContext } from 'react'
import { CutterContext } from '../contexts/CutterContext'

export function useGetVisibleRatioPosition(): (ratio: number) => Position {
  const { visibleRange } = useContext(CutterContext)

  return useCallback((ratio) => visibleRange[0] + (visibleRange[1] - visibleRange[0]) * ratio, [visibleRange])
}
